import React from 'react'
import styled, {useTheme} from 'styled-components'
import {Box, Heading, Image, Text, Link} from '@miro-site/core'
import {ICustomerSpotlight} from '../api/interfaces'

const Container = styled(Box).attrs(({theme}) => ({
  $py: theme.header.customerSpotlight.verticalPadding,
  $px: theme.header.customerSpotlight.horizontalPadding,
  $styles: {
    borderRadius: theme.header.highlighted.radius,
    backgroundColor: theme.header.highlighted.background,
  },
}))``

const Blockquote = styled(Text).attrs(({theme}) => ({
  as: 'blockquote',
  $variant: theme.header.customerSpotlight.quote.variant,
  $styles: {color: theme.header.colors.secondaryText},
}))`
  &:before {
    content: '“';
  }

  &:after {
    content: '”';
  }
`

const Headline = styled(Heading).attrs(({theme}) => ({
  as: theme.header.customerSpotlight.headline.as,
  $mb: theme.header.customerSpotlight.margins.afterHeadline,
  $variant: theme.header.customerSpotlight.headline.variant,
}))``

const ViewAllLink = styled(Link).attrs(({theme}) => ({
  $variant: theme.header.customerSpotlight.viewAllLink.variant,
  $color: theme.header.customerSpotlight.viewAllLink.color,
  $size: theme.header.customerSpotlight.viewAllLink.size,
  withArrow: theme.header.customerSpotlight.viewAllLink.withArrow,
}))``

const CustomerSpotlight = (props: ICustomerSpotlight): React.ReactElement => {
  const {title, description, image, logo, showAllLink} = props

  const {
    header: {customerSpotlight},
  } = useTheme()

  return (
    <Container>
      <Headline>{title}</Headline>
      {image && (
        <Box
          $mb={customerSpotlight.margins.afterImage}
          $styles={{maxWidth: customerSpotlight.imageWidth}}
        >
          <Image {...image} />
        </Box>
      )}

      {logo && (
        <Box
          $mb={customerSpotlight.margins.afterLogo}
          $styles={{maxWidth: customerSpotlight.logoWidth}}
        >
          <Image {...logo} />
        </Box>
      )}
      <Blockquote $mb={customerSpotlight.margins.afterQuote}>{description}</Blockquote>
      {showAllLink && <ViewAllLink href={showAllLink.path}>{showAllLink.title}</ViewAllLink>}
    </Container>
  )
}

export default CustomerSpotlight
